import { Tooltip } from "@appkit4/react-components";
import { useMemo, useState } from "react";
import DataImportModal from "../../../components/DataImportModal/DataImportModal";
import { BackButton, NextButton } from "../../../components/ProgressNav";
import { Button } from "../../../components/ReadonlyAwareInputs";
import { disableProgressInViewMode } from "../../../services/GroupContext";
import "../entityInput.scss";

const EntityInputNav = ({
  data,
  isPosting,
  set_data,
  isError,
  isAPsError,
  save,
  checkForAPsOverlapOrGap
}) => {
  const disableViewModeProgress = disableProgressInViewMode();

  return (
    <div className="container-fluid mt-4">
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex gap-2">
          <BackButton disabled={isPosting} />
          <DataImportModal
            pageName="entityInput"
            data={data}
            setData={set_data}
          />
        </div>

        <div className="d-flex gap-2">
          <Tooltip
            content="Credit for foreign taxes must be not be greater than 0"
            disabled={!isError}
          >
            <span>
              <Button
                hiddenInReadonly
                loading={isPosting}
                disabled={isError || isAPsError}
                onClick={save}
                kind="secondary"
              >
                Save
              </Button>
            </span>
          </Tooltip>
          <Tooltip
            content="Credit for foreign taxes must be not be greater than 0"
            disabled={!isError}
          >
            <span>
              <NextButton
                loading={isPosting}
                preNavigation={save}
                preventNavigation={checkForAPsOverlapOrGap}
                disabled={isError || isAPsError || disableViewModeProgress}
              />
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default EntityInputNav;
